<template lang="pug">
  .root
    the-heading(:caption="'Информация об использовании системы'")
    .container
      .main_block
        .globalCaptionStyles Информация об использовании системы
        .info_block
          .cursive_text
            | Данные «Webiomed» и любая информация, предоставленная в отношении программного продукта, предназначены только для информационных целей и не должны быть использованы для замены профессиональных медицинских консультаций. Окончательные постановка диагноза, назначение лечения и профилактических мероприятий осуществляются врачом.
          br
          h4  ОБЩАЯ ИНФОРМАЦИЯ
          div
            | Программное обеспечение «Система для поддержки принятия врачебных решений «WEBIOMED» по ТУ 62.01.29-001-12860736-2019 - облачная система поддержки принятия врачебных решений с использованием методов искусственного интеллекта (далее «Система», «СППВР» или «Продукт»).
          br
          div
            | Продукт разработан с применением методов искусственного интеллекта, выводы которого основаны на тщательном и системном анализе доступных в период его подготовки научных данных, результатах доказательной медицины, утвержденных клинических рекомендациях и стандартах оказания медицинской помощи.
          br
          div
            | Компания разработчик Продукта – ООО «К-Скай». Все права защищены. 2020 г.
          div
            | Эмблема «Webiomed» является зарегистрированным товарным знаком ООО «К-Скай»
            br
            span Свидетельство № 609678 от 25.12.2017.
          br
          div
            | СППВР «Webiomed» зарегистрирована в Федеральной службе по интеллектуальной собственности, свидетельство на регистрацию программы для ЭВМ №2018661424 от 07.09.2018г.
          br
          div
            | СППВР «Webiomed» зарегистрировано Минкомсвязью как Российская разработка и размещена в «Едином реестре российских программ для электронных вычислительных машин и баз данных», регистрационный номер 4980 на основании Приказа Минкомсвязи России от 30.11.2018 №665.
          br
          div
            | Ссылка на регистрационную карточку:
          br
          div
            a(:href="'https://reestr.minsvyaz.ru/reestr/139085/'" add target="_blank")
              span  https://reestr.minsvyaz.ru/reestr/139085/
              //- v-icon(name="external-link-alt")
          br
          div
            | СППВР «Webiomed» является медицинским изделием. Регистрационное удостоверение на медицинское изделие № РЗН 2020/9958 от 03.04.2020.
          br

          h4 ИСПОЛЬЗОВАНИЕ И РАСКРЫТИЕ ДАННЫХ В МЕДИЦИНСКИХ ОРГАНИЗАЦИЯХ
          div
            | Предоставленные данные СППВР являются результатом анализа деперсонифицированных медицинских данных пациента. Полученные результаты анализа (консультации) являются рекомендательной информацией и не могут быть интерпретированы как точный диагноз или назначение окончательного лечения конкретному пациенту.
          br
          div
            | Продукт предназначен только для информационных целей, и, хотя, предоставленная информация может указывать на диагноз или возможное лечение, её всегда следует подтверждать и дополнять медицинскими обследованиями и информацией.
          br
          div
            | Использование данных Системы для публикаций, исследований или в коммерческих целях не допускается. В частности, пользователь Системы признает, что не будет получать никакой выгоды от какой-либо публикации или исследования, основанного на предоставленных на сайте данных. Пользователь Системы соглашается не отображать, не распространять, не публиковать, не воспроизводить, не дублировать, не продавать, не модифицировать, не передавать в коммерческих целях весь или любую часть Продукта. В случае нарушения любого из этих представлений компания разработчик имеет право приостановить или прекратить действие учетной записи и отказаться от любого текущего или будущего использования Продукта (или любой его части).
          br
          div
            | Компания разработчик уважает конфиденциальность пользователя. Мы никогда не будем продавать, сдавать в аренду вашу контактную информацию. Мы не будем раскрывать вашу личную информацию, если только закон не требует от нас этого.
          br
          div
            | Вы признаете и соглашаетесь с тем, что мы имеем право в любое время контролировать и исследовать ваше изображение / данные, представленные в Продукте, и хранить копии, документирующие такой мониторинг и исследования.
          br
          h4 НАЗНАЧЕНИЕ ПРОДУКТА
          div
            | «Webiomed» – это инновационный программный продукт, основанный на искусственном интеллекте. Продукт реализован в виде облачного веб-сервиса и позволяет на основе автоматического анализа медицинских данных прогнозировать риски развития заболеваний, предоставлять по клиническим случаям персональные рекомендации врачу и пациенту. Система может быть интегрирована с медицинскими информационными системами. Продукт анализирует электронные медицинские карты методами искусственного интеллекта (экспертные аналитические системы и машинное обучение).
          br
          div
            a(ui-sref='webiomedPatientAnalysisResponsibility')
              //- | Подробнее (Руководство пользователя)
              //- i.fa.fa-external-link
          h4 ИЗМЕНЕНИЯ В ПРОДУКТЕ
          div
            | Компания разработчик оставляет за собой право в любое время и время от времени изменять или прекращать временно или навсегда выпускать Продукт (или любую его часть) с уведомлением или без него. Используемое вами программное обеспечение может время от времени автоматически загружать и устанавливать обновления из Продукта. Эти обновления предназначены для улучшения и дальнейшего развития Продукта. Пользователь соглашается получать такие обновления в рамках использования Продукта.
          br
          h4 ОТКАЗ ОТ ОТВЕТСТВЕННОСТИ
          div
            | Данные «Webiomed» и любая информация в отношении программного продукта, предназначены только для информационных целей и не должны быть использованы для замены профессиональных медицинских консультаций. Окончательная постановка диагноза, назначение лечения и профилактических мероприятий осуществляются врачом.
          br
          div
            | Продукт не предназначен для самостоятельного обследования, диагностики и назначения лечения пациенту иным лицом, кроме лечащего врача.
          br
          div
            | Лечащий врач свободен в выборе диагностических и лечебных методов при оказании медицинской помощи, и ответственен за свои решения и действия. Только лечащий врач устанавливает окончательный диагноз на основании своевременного и всестороннего обследования пациента с составлением медицинского заключения об основном заболевании или состоянии, сопутствующих заболеваниях и осложнениях, вызванных основным заболеванием и сопутствующим заболеванием.
          br
          div
            | Лечащий врач предоставляет информацию о состоянии здоровья пациента, по требованию пациента или его законного представителя приглашает для консультаций врачей-специалистов, при необходимости созывает консилиум врачей, рекомендации которых реализуются по согласованию с лечащим врачом.
          br
          div
            | Целью лечения является устранение или облегчение проявлений заболевания либо состояний пациента, восстановление или улучшение его здоровья, трудоспособности и качества жизни. Медицинские работники вправе при осуществлении своей профессиональной деятельности руководствоваться рекомендациями сервиса «Webiomed» в процессе принятия клинических решений.
          br
          div
            | Компания разработчик сервиса «Webiomed» принимает разумные меры для обеспечения точности, актуальности и правомерности содержимого Системы, но не принимает на себя ответственности за действия органов государственной власти, управления, физических и юридических лиц, прямо или иным образом внесших изменения в действующие медицинские документы, осуществленные действия на основании информации, имеющейся в системе или полученной через нее, как предоставленной Владельцами Сервиса, так и третьими лицами.
          br
          h4 ХРАНИЛИЩЕ ДАННЫХ
          div
            | Компания разработчик прилагает все усилия, чтобы следовать самым последним стандартам защиты. Продукт настроен на меры безопасности, которые обеспечивают надежную работу и хранение данных.
          br
          h4 ОТКАЗ ОТ ГАРАНТИЙ
          div Пользователь Продукта подтверждает и соглашается, что:
          br
          div (1) Использует Продукт на свой риск. Продукт предоставляется на основе «как есть» и «как доступно». Разработчик «Webiomed» отказывается от всех гарантий любого вида, явных или подразумеваемых, включая, но не ограничиваясь, на подразумеваемые гарантии товарного обеспечения, пригодности для особых целей и неправильных.
          br
          div (2) «Webiomed» не предоставляет никаких гарантий, которые соответствуют следующим определениям:
          br
          div Продукт ответит любым требованиям; (b) Продукт будет непрерывно безопасным или безопасным; (с) качество любых продуктов, услуг, информации или другого материала, покупаемого или полученного вами в течение срока жизни Продукта, соответствует ожиданиям, и (d) любые ошибки в программном обеспечении будут исправлены.
          br
          div (3) Никакие консультации или информация, полученные из Продукта, не создают никаких гарантий, не указанных явно относительно условий.
          br
          div Компания разработчик сервиса «Webiomed» не несет ответственности за выявленные противоречия, неоднозначные выводы, расхождения между рекомендациями сервиса и официальными клиническими рекомендациями. Такие расхождения могут быть вызваны недостаточным объемом информации о пациенте или недостаточными научными сведениями в этой области. Окончательное решение о выборе способа лечения пациента обязан принять лечащий врач, руководствующийся принципами профессиональных и этических норм.
          br
          h4 СОГЛАСИЕ
          div Пользователь согласен с тем, что прочитал данные условия использования Продукта, соблюдает и понимает каждый параграф, содержащийся в настоящих Условиях.
          br
          br
          br
          br
          br
</template>
<script>
import TheHeading from '@/components/parts/TheHeading'
import Icon from 'vue-awesome/components/Icon'

export default {
  components: {
    TheHeading,
    'v-icon': Icon
  }
}
</script>
<style lang="sass" scoped>
@import "@/css/DefaultStyles.sass"
.globalCaptionStyles
  margin: 40px 160px
.info_block
  margin: 40px 160px
  font-size: 17px
  line-height: 1.42857143
.cursive_text
  font-style: italic
h4
  color: #046875
  font-weight: 500
  font-size: 18px
a
  text-decoration: none
  font-weight: 450
a:hover
  text-decoration: underline
</style>
